import type { CustomNode, CustomEdge, CustomNodeData } from '@src/components/custom-nodes/types';

import { NODES_TO_PASTE_CONDITION_AFTER } from '@src/consts';

export const getValidIfStatementPositions = (
  nodesToProcess: CustomNode[],
  nodes: CustomNode[],
  edges: CustomEdge[],
  excludeNodeIds: string[] = []
) => {
  return nodesToProcess.filter((node) => {
    const acceptedNodes =
      NODES_TO_PASTE_CONDITION_AFTER.includes((node.data as CustomNodeData)?.nodeType ?? '')
      && !excludeNodeIds.includes(node.id)
        ? [node]
        : [];

    function traverseNodesUp(nodeId: string) {
      const parentNodeId = edges.find((edge) => edge.target === nodeId)?.source;
      const parentNode = nodes.find((node) => node.id === parentNodeId)!;
      const parentNodeData = parentNode?.data as CustomNodeData;
      if (NODES_TO_PASTE_CONDITION_AFTER.includes(parentNodeData?.nodeType ?? '')) {
        if (!excludeNodeIds.includes(parentNode.id)) {
          acceptedNodes.push(node);
        }
      }
      if (parentNodeId) {
        traverseNodesUp(parentNodeId);
      }
    }

    traverseNodesUp(node.id);

    return acceptedNodes.length;
  });
};
